(function () {
  /**
   * BatchGeo's rectangle selection Drawing Manager tool. It allows you to
   * click and drag over markers to select them.
   */
  var BatchGeoDrawingManagerRectangle = $.extend(
    true,
    {},
    window.BatchGeoDrawingManagerBaseTool,
    {
      button: {
        class: "drawing-manager-button drawing-manager-button-rectangle",
        title: "Rectangle selection tool",
        order: 3,
        icon: "rectangle",
        mode: "rectangle",
      },

      // See BaseTool for docs on this method
      buildShape: function () {
        return new google.maps.Rectangle(
          $.extend(
            {
              map: this.drawingManager.settings.map,
              bounds: new google.maps.LatLngBounds(
                this.startPosition,
                this.startPosition,
              ),
              ...this.drawingManager.settings.shapeOptions,
            },
            this.options,
          ),
        );
      },

      /**
       * Given a rectangle's bounds, it will return the 4 points in ne, nw, se, sw
       * coordinates in Google Map's LatLng objects.
       *
       * @param  {object} bounds A Google Map's bounds object
       * @return {object}        An object with ne, nw, se, sw + their LatLngs
       */
      _getRectangleBoundsPoints: function (bounds) {
        var points = {
          ne: bounds.getNorthEast(),
          sw: bounds.getSouthWest(),
        };

        points.nw = new google.maps.LatLng(points.ne.lat(), points.sw.lng());
        points.se = new google.maps.LatLng(points.sw.lat(), points.ne.lng());

        return points;
      },
      // See BaseTool for docs on this method
      resizeShapeHandler: function (event) {
        if (this.__event) {
          google.maps.event.removeListener(this.__event);
        }

        const drawingManager = this.drawingManager;
        const dragDirectionNegativeX = event.pageX - this.startEvent.pageX < 0;
        let bounds;

        // If we subtract the current pageX from the start pageX and it's less
        // than 0 we're in negative numbers meaning we're dragging to the left and
        // therefore we need to flip the start position of the bounds then if it
        // was a positive number / dragging the mouse to the right.
        if (dragDirectionNegativeX) {
          bounds = new google.maps.LatLngBounds(
            drawingManager.fromEventToLatLng(event),
            this.startPosition,
          );
        } else {
          bounds = new google.maps.LatLngBounds(
            this.startPosition,
            drawingManager.fromEventToLatLng(event),
          );
        }

        this.shape.setOptions({ bounds });

        const points = this._getRectangleBoundsPoints(bounds);
        const width = drawingManager.distanceBetweenTwoLatLng(
          points.ne,
          points.nw,
        );
        const height = drawingManager.distanceBetweenTwoLatLng(
          points.nw,
          points.sw,
        );
        const scale = drawingManager.getDistanceScale();

        this.label.setPosition(
          dragDirectionNegativeX ? points.sw : points.ne,
          "rectangle",
        );
        this.label.render(
          width.toFixed(2) + scale + " x " + height.toFixed(2) + scale,
        );
      },

      /**
       * See BaseTool for docs on this method
       * @override
       */
      drawEndHandler: function () {
        this.drawingManager.disableMapPanning();
        if (this.shape) {
          if (this.shape.map) {
            this.selectionHandler(this.shape);
          }

          this.prevShapes = [
            ...this.prevShapes,
            new google.maps.Rectangle({
              ...this.drawingManager.settings.shapeOptions,
              map: this.drawingManager.settings.map,
              bounds: this.shape.getBounds(),
            }),
          ];

          this.shape.setMap(null);
          delete this.shape;
        }

        BatchGeoStore.dispatch({
          type: "DRAWING_MANAGER_SELECTION_STATUS",
          status: false,
        });
      },

      /**
       * Handles what happens when a selection is complete on mouseup which is
       * mainly finding which markers were in the selection. It finally sends off
       * a select event with the selected markers.
       *
       * @param  {object} selection A Google Maps Rectangle object
       * @return {undefined}
       */
      selectionHandler: function (selection) {
        var selectionBoundsSw = selection.getBounds().getSouthWest();
        var selectionBoundsNe = selection.getBounds().getNorthEast();

        // If the bounds are identical the user didn't select any area at all so
        // just return out early and prevent deselecting and wasting time looping
        // through all markers
        if (
          selectionBoundsSw.lat() == selectionBoundsNe.lat() &&
          selectionBoundsSw.lng() == selectionBoundsNe.lng()
        ) {
          return;
        }

        // We need to create a new bounds to check the marker position against.
        // Why we have to do this is a mystery to me still, but after numerous
        // trial and errors this was the only way to get a truthy contains()
        var selectionBounds = new google.maps.LatLngBounds(selectionBoundsSw);
        selectionBounds.extend(selectionBoundsNe);

        this.processSelection((item) => {
          return selectionBounds.contains(item.getPosition());
        });
      },
    },
  );

  window.BatchGeoDrawingManagerRectangle = BatchGeoDrawingManagerRectangle;
})(window);
